import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import store from '../../store';
import {
	selectIomoCap,
	selectIomoCapInclCustom, selectIomoColourTemperature,
	selectIomoColourTemperatureInclCustom,
	selectIomoDesign,
	selectIomoLightDistribution, selectIomoLightDistributionInclCustom,
	selectIomoModifier, selectIomoModifierInclCustom, selectIomoReflectorColour, selectIomoReflectorColourInclCustom,
} from '../iomoSelectors';
import {iomoCapOptions, iomoColourTemperatureOptions, iomoLightDistributionOptions, iomoModifierOptions, iomoReflectorColourOptions} from '../iomoModel';

@customElement('iomo-single-luminaire-settings')
export class IomoSingleLuminaireSettings extends connect(store)(LitElement) {

	static styles = [
		css`
			:host {
				display: flex;
				break-inside: avoid;
				flex-flow: column;
				place-content: flex-start;
				gap: var(--small-padding);
			}

			.box {
				background-color: var(--color-widget-background);
				padding: 12px;
				display: flex;
				break-inside: avoid;
				flex-flow: column;
				place-content: flex-start;
				gap: var(--large-space);
			}
		`
	];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.lang = state.status.lang;
		this.system = selectIomoDesign(state);
	}

	reflectorColourCanBeSelected(state, id) {
		return true;
	}

	colourTemperatureCanBeSelected(state, id) {
		return !(selectIomoReflectorColour(state) === 'Gold' && id === '3000K') &&
			!(selectIomoReflectorColour(state) === 'Gold' && id === '4000K');
	}

	lightDistributionCanBeSelected(state, id) {
		return true;
	}
	modifierCanBeSelected(state, id) {
		return true;
	}
	capCanBeSelected(state, id) {
		return true;
	}
	render() {
		return html`
			<div class="box">
				<list-select
					.title=${{de: 'Reflektorfarbe', en: 'Reflector Colour', fr: 'couleur réflecteur'}}
					.options=${iomoReflectorColourOptions}
					action='iomo/setIomoReflectorColour'
					.selected=${selectIomoReflectorColour}
					.canBeSelected=${this.reflectorColourCanBeSelected}
					.isSatisfied=${() => true}>
				</list-select>

				<list-select
					.title=${{
						de: 'Lichtfarbe',
						en: 'Light color',
						fr: 'température de couleur'
					}}
					.options=${iomoColourTemperatureOptions}
					action='iomo/setIomoColourTemperature'
					.selected=${selectIomoColourTemperature}
					.canBeSelected=${this.colourTemperatureCanBeSelected}
					.isSatisfied=${() => true}>
				</list-select>

				<list-select
					.title=${{
						de: 'Abstrahlcharakteristik',
						en: 'light distribution',
						fr: 'distribution photométrique'
					}}
					.options=${iomoLightDistributionOptions}
					action='iomo/setIomoLightDistribution'
					.selected=${selectIomoLightDistribution}
					.canBeSelected=${this.lightDistributionCanBeSelected}
					.isSatisfied=${() => true}>
				</list-select>

				<list-select
					.title=${{
						de: 'Lichtmodifikation',
						en: 'light modifier',
						fr: 'light modifier'
					}}
					.options=${iomoModifierOptions}
					action='iomo/setIomoModifier'
					.selected=${selectIomoModifier}
					.canBeSelected=${this.modifierCanBeSelected}
					.isSatisfied=${() => true}>
				</list-select>

				<list-select
					.title=${{
						de: 'Schute',
						en: 'cap',
						fr: 'cap'
					}}
					.options=${iomoCapOptions}
					action='iomo/setIomoCap'
					.selected=${selectIomoCap}
					.canBeSelected=${this.capCanBeSelected}
					.isSatisfied=${() => true}>
				</list-select>
			</div>
		`;
	}
}
